export function initCursorDot() {
    const dot = document.getElementById('gh-cursor');
    if (!dot) return;
    if (window.matchMedia('(hover: none)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    let ticking = false;
    let lastX = 0;
    let lastY = 0;

    const update = () => {
        dot.style.setProperty('--cursor-x', `${lastX}px`);
        dot.style.setProperty('--cursor-y', `${lastY}px`);
        ticking = false;
    };

    const onMove = (e) => {
        lastX = e.clientX;
        lastY = e.clientY;
        dot.classList.add('is-active');
        if (!ticking) {
            requestAnimationFrame(update);
            ticking = true;
        }
    };

    const onLeave = () => {
        dot.classList.remove('is-active');
    };

    window.addEventListener('mousemove', onMove);
    window.addEventListener('mouseleave', onLeave);
}
